import { jsx as _jsx } from "react/jsx-runtime";
import { Stack } from '@chakra-ui/react';
import { ThemeColorVariable, ThemeSpaceVariable, } from '@caspeco/casper-ui-library.base-ui.theme';
import { StepContext } from './stepContext';
import { Step } from './step';
/**
 * A representation of a progress through a series of steps.
 *
 * @see Docs https://bit.cloud/caspeco/casper-ui-library/components/stepper
 */
export function Stepper({ activeStep, orientation = 'vertical', steps = [], ...props }) {
    const isVertical = orientation === 'vertical';
    const stepsContent = steps.map((step, index) => {
        const number = index + 1;
        const stepContext = {
            orientation,
            isActiveStep: activeStep === number,
            showDivider: index !== steps.length - 1,
            label: step.label,
            icon: step.icon,
            color: step.color ?? ThemeColorVariable.OnBackgroundBorder,
            iconColor: step.iconColor ?? ThemeColorVariable.OnBackground,
            dividerColor: (step.dividerColor || step.color) ??
                ThemeColorVariable.OnBackgroundBorder,
        };
        return (_jsx(StepContext.Provider, { value: stepContext, children: _jsx(Step, {}) }, number));
    });
    return (_jsx(Stack, { spacing: ThemeSpaceVariable.Small, direction: isVertical ? 'column' : 'row', ...props, children: stepsContent }));
}
//# sourceMappingURL=stepper.js.map